import $ from 'jquery';
export let open_menu_state = 0;

/**
 * Close Modal
 * @param {*} selector ID du modal
 */
export const closeModal = {
    closeModal(selector) 
    {
        $('#'+selector).removeClass('animate-zoomIn');
        $('#'+selector).addClass('animate-zoomOut');
        $('.modal').fadeOut();
        // $('.modal-backdrop').fadeOut()
        $('.modal-backdrop').removeClass('modal-backdrop')
        $('.modal-open').removeClass('modal-open')


        setTimeout(() => {
            $('#'+selector).removeClass('animate-zoomOut');
            $('#'+selector).addClass('animate-zoomIn');
        }, 500);
    }
}

/**
 * Open Menu dropdown
 */
 export const openMenu = {
    dropMenu: function(v, selector, show_in, show_out) {

        if (v == 0) {
            v = 1;
        } else {
            v = 0;
        }

            $('.drp-menu').fadeOut();

        if (open_menu_state == 0) {
            $('.' + selector).fadeIn();
            $('.' + selector).removeClass(show_out);
            $('.' + selector).addClass(show_in);
        } else {
            $('.' + selector).removeClass(show_in);
            $('.' + selector).addClass(show_out);
            $('.' + selector).fadeOut();
        }

        open_menu_state = v;

        return open_menu_state;
    }
}

/**
 * close Menu Dropdown
 */
export const closeMenu = {
    wrapMenu: function(selector, show_in, show_out) {
        $('.' + selector).removeClass(show_in);
        $('.' + selector).addClass(show_out);
        $('.' + selector).fadeOut();
        open_menu_state = 0;

        return open_menu_state;
    }
}

/**
 * Convertir la Date au format yyyy-mm-dd
 * @param {*} date 
 * @returns 
*/
export const convertDateToYyyyMmDd = {
    convertDate: function(date) {
        let dd = (date.getDate() <= 9)?'0'+date.getDate():date.getDate();
        let mm = ((date.getMonth() + 1) <= 9)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
        let y = date.getFullYear();
    
        return y + '-' + mm + '-' + dd;
    }
}

/**
 * Convertir la Date au format dd/mm/yyyy
 * @param {*} date 
 * @returns 
*/
export const convertDateToDdMmYyyy = {
    convertDate: function(date) {
        let dd = (date.getDate() <= 9)?'0'+date.getDate():date.getDate();
        let mm = ((date.getMonth() + 1) <= 9)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
        let y = date.getFullYear();
    
        return dd + '/' + mm + '/' + y;
    }
}